module.exports = __webpack_public_path__ + "static/media/calc_top.c41ef77c.svg";